import Vue from 'vue'
import VueRouter from 'vue-router'

import Base from '@/components/core-components/base/Base.vue'

/* Auth */
const Login = () => import( /* webpackChunkName: "auth" */ "@/components/auth/login/login.vue")
const SignUp = () => import( /* webpackChunkName: "auth"  */ '@/components/auth/signup/SignUp.vue')
const VerifyOtp = () => import( /* webpackChunkName: "auth"  */ '@/components/auth/verify-otp/VerifyOtp.vue')
const AuthBase = () => import( /* webpackChunkName: "auth"  */ '@/components/auth/AuthBase.vue')
const ForgetPassword = () => import( /* webpackChunkName: "auth"  */ '@/components/auth/forget-password/ForgetPassword.vue')

/* dashboard */
// import Shipments from '@/components/shipments/Shipments.vue'
const ShipmentList = () => import( /* webpackChunkName: "shipment" */ '@/components/shipments/ShipmentList.vue')
const ShipmentDetails = () => import( /* webpackChunkName: "shipment" */ '@/components/shipments/ShipmentDetails.vue')
const AcceptShipment = () => import( /* webpackChunkName: "shipment" */ '@/components/shipments/AcceptShipment.vue')
const DropShipment = () => import( /* webpackChunkName: "shipment" */ '@/components/shipments/DropShipment.vue')


const NotificationList = () => import( /* webpackChunkName: "notification-list" */ '@/components/notification/NotificationList.vue')

const DispatchShipment = () => import( /* webpackChunkName: "dispatch-shipments" */ '@/components/dispatch-shipment/DispatchShipment.vue')
const DispatchHistory = () => import( /* webpackChunkName: "dispatch-shipments" */ '@/components/dispatch-shipment/DispatchHistory.vue')
const TripDetails = () => import( /* webpackChunkName: "dispatch-shipments" */ '@/components/dispatch-shipment/TripDetails')


const NewShipment = () => import( /* webpackChunkName: "new-shipment" */ '@/components/new-shipment/NewShipment.vue')
const BulkShipment = () => import( /* webpackChunkName: "new-shipment" */ '@/components/new-shipment/BulkShipment.vue')
const CreateShipment = () => import( /* webpackChunkName: "new-shipment" */ '@/components/new-shipment/CreateShipment.vue')

const Overview = () => import( /* webpackChunkName: "overview" */ '@/components/overview/Overview.vue')

const Products = () => import( /* webpackChunkName: "product" */ '@/components/products/Products.vue')
const NewProduct = () => import( /* webpackChunkName: "product" */ '@/components/products/NewProduct.vue')

/* wallet and withdrawal*/
const Wallet = () => import( /* webpackChunkName: "wallet" */ '@/components/wallet/Wallet.vue')
const WalletShipmentList = () => import( /* webpackChunkName: "wallet" */ '@/components/wallet/WalletShipmentList.vue')
const WithdrwalDetails = () => import( /* webpackChunkName: "wallet" */ '@/components/wallet/WithdrwalDetails.vue')
const Collection = () => import( /* webpackChunkName: "collection" */ '@/components/collection/Collection')
const CollectionHistory = () => import( /* webpackChunkName: "collection" */ '@/components/collection/CollectionHistory')
const CollectionDetails = () => import( /* webpackChunkName: "collection" */ '@/components/collection/CollectionDetails')

/* Withdrawal */
const Withdrawal = () => import( /* webpackChunkName: "withdrawal" */ '@/components/withdrawal/Withdrawal.vue')
const InitiateWithdrawal = () => import( /* webpackChunkName: "withdrawal" */ '@/components/withdrawal/InitiateWithdrawal.vue')

/* support ticket */
const SupportTicketsList = () => import( /* webpackChunkName: "support-ticket" */ '@/components/support-tickets/SupportTicketsList.vue')
const RaiseIssue = () => import( /* webpackChunkName: "support-ticket" */ '@/components/support-tickets/RaiseIssue.vue')
const SupportTicketDetails = () => import( /* webpackChunkName: "support-ticket" */ '@/components/support-tickets/SupportTicketDetails.vue')


const Subscriptions = () => import( /* webpackChunkName: "subscription" */ '@/components/subscriptions/Subscriptions.vue')

// wholesaler
const WholesaleProfile = () => import( /* webpackChunkName: "wholesaler" */ "@/components/wholesaler/Profile")
const WholesaleProfileDetails = () => import /* webpackChunkName: "wholesaler" */("@/components/wholesaler/ProfileDetails")
const WholesaleEditProfile = () => import( /* webpackChunkName: "wholesaler" */ "@/components/wholesaler/EditProfile")
const ManageWholesaler = () => import( /* webpackChunkName: "wholesaler" */ "@/components/wholesaler/ManageWholesaler")

/*Manage*/

const Manage = () => import( /* webpackChunkName: "retailer" */ "@/components/manage/Manage")

/* Retailer */
const ManageRetailer = () => import( /* webpackChunkName: "retailer" */ "@/components/manage/retailer/ManageRetailer")
const AddRetailer = () => import /* webpackChunkName: "retailer" */("@/components/manage/retailer/AddRetailer")
const RetailerDetails = () => import( /* webpackChunkName: "retailer" */ "@/components/manage/retailer/RetailerDetails")

/* Agents*/
const AddAgents = () => import( /* webpackChunkName: "agents" */ "@/components/manage/agents/AddAgents")
const ManageTeam = () => import( /* webpackChunkName: "agents" */ "@/components/manage/agents/ManageTeam")
const EmployeeDetails = () => import( /* webpackChunkName: "agents" */ "@/components/manage/agents/EmployeeDetails")

const AddSubscriptionPlan = () => import( /* webpackChunkName: "agents" */ "@/components/manage/subscription/AddSubscriptionPlan")

const Payouts = () => import( /* webpackChunkName: "payouts" */ "@/components/manage/payouts/Payouts")
const PayoutDetails = () => import( /* webpackChunkName: "payouts" */ "@/components/manage/payouts/PayoutDetails")

const SubscriptionPlans = () => import( /* webpackChunkName: "warehouses" */ "@/components/manage/subscription/SubscriptionPlans.vue")
const UserSubscription = () => import( /* webpackChunkName: "warehouses" */ "@/components/manage/user-subscription/UserSubscription.vue")
const SubscribeUser = () => import( /* webpackChunkName: "warehouses" */ "@/components/manage/user-subscription/SubscribeUser.vue")
const SubscriptionPaymentPage = () => import( /* webpackChunkName: "subscriptionpaymentpage" */ "@/components/manage/user-subscription/SubscriptionPaymentPage.vue")


const Warehouses = () => import( /* webpackChunkName: "warehouses" */ "@/components/manage/warehouses/Warehouses")
const CreateWarehouse = () => import( /* webpackChunkName: "warehouses" */ "@/components/manage/warehouses/CreateWarehouse")

const AddLine = () => import( /* webpackChunkName: "line" */ "@/components/manage/line/AddLine")
const ManageLine = () => import( /* webpackChunkName: "line" */ "@/components/manage/line/ManageLine")
const LineDetails = () => import( /* webpackChunkName: "line" */ "@/components/manage/line/LineDetails")

const RetailerOfferImages = () => import( /* webpackChunkName: "offer-images" */ "@/components/manage/offer-images/RetailerOfferImages")
const WholesalerOfferImages = () => import( /* webpackChunkName: "offer-images" */ "@/components/manage/offer-images/WholesalerOfferImages")


// Others
const Faq = () => import( /* webpackChunkName: "others" */ "@/components/others/Faq")
const MapTracking = () => import( /* webpackChunkName: "map" */ "@/components/common-components/MapTracking.vue")
const ShippingLabel = () => import( /* webpackChunkName: "map" */ "@/components/common-components/ShippingLabel2.vue")

const WarehouseProfile = () => import( /* webpackChunkName: "WarehouseProfile" */ "@/components/warehouse/WarehouseProfile.vue")

Vue.use(VueRouter)

const routes = [{
    path: '/map/',
    name: 'map',
    component: MapTracking,
},
    {
        path: '/subscription-payment-page/',
        name: 'subscription-payment-page',
        component: SubscriptionPaymentPage,
    },
    {
        path: '/shipping-label/:id',
        name: 'shipping-label',
        component: ShippingLabel,
    },

    {
        path: '/user',
        name: 'authBase',
        component: AuthBase,
        children: [{
            path: '/wholesaler/login',
            name: 'wholesaler-login',
            component: Login,
        },
            {
                path: '/warehouse/login',
                name: 'warehouse-login',
                component: Login,
            },
            {
                path: '/signup',
                name: 'signup',
                component: SignUp,
            },
            {
                path: '/verify',
                name: 'verify',
                component: VerifyOtp,
            },

            {
                path: '/forget-password',
                name: 'forget-password',
                component: ForgetPassword
            },
        ]
    },

    {
        path: '/',
        name: 'base',
        component: Base,
        // redirect: { name: "overview" },
        children: [
            /* NEW SHIPMENT*/
            // {
            //   path: '/new',
            //   name: 'create-shipment',
            //   component: NewShipment,
            //   redirect: { name: "new-shipment" },
            // },
            {
                path: 'new/shipment',
                name: 'new-shipment',
                component: BulkShipment
            },
            // {
            //   path: 'new/shipment/bulk-shipment',
            //   name: 'bulk-shipment',
            //   component: BulkShipment
            // },
            /* OVERVIEW */
            {
                path: '/overview',
                name: 'overview',
                component: Overview
            },

            /*SHIPMENTS */
            {
                path: '/shipments/',
                name: 'shipments',
                component: ShipmentList,
            },
            {
                path: '/shipments/shipment-details/:shipment_id',
                name: 'shipment-details',
                component: ShipmentDetails,
            },
            // temporary

            {
                path: '/accept-shipment',
                name: 'accept-shipment',
                component: AcceptShipment,
            },
            {
                path: '/drop-shipment',
                name: 'drop-shipment',
                component: DropShipment,
            },
            {
                path: '/dispatch-shipment',
                name: 'dispatch-shipment',
                component: DispatchShipment,
            },
            {
                path: '/dispatch-history',
                name: 'dispatch-history',
                component: DispatchHistory,
            },
            {
                path: '/dispatch-details/:trip_id',
                name: 'dispatch-details',
                component: TripDetails,
            },
            /* Notification List */
            {
                path: '/notification-list',
                name: 'notification-list',
                component: NotificationList,
            },


            /* WALLET */
            {
                path: '/wallet',
                name: 'wallet',
                component: Wallet
            },
            {
                path: '/wallet/returns',
                name: 'returns',
                component: WalletShipmentList
            },
            {
                path: '/wallet/collections',
                name: 'collections',
                component: WalletShipmentList
            },
            {
                path: '/wallet/withdrawal-details/:transaction_id',
                name: 'withdrawal-details',
                component: WithdrwalDetails
            },

            {
                path: '/collection',
                name: 'collection',
                component: Collection
            },
            {
                path: '/collection/collection-history',
                name: 'collection-history',
                component: CollectionHistory
            },
            {
                path: '/collection/collection-details/:transaction_id',
                name: 'collection-details',
                component: CollectionDetails,
            },

            /* WITHDRAWAL */
            {
                path: '/withdrawal',
                name: 'withdrawal',
                component: Withdrawal
            },
            {
                path: '/withdrawal/withdrawal-details/:transaction_id',
                name: 'withdrawal--details',
                component: WithdrwalDetails
            },
            {
                path: '/withdrawal/initiate-withdrawal',
                name: 'initiate-withdrawal',
                component: InitiateWithdrawal
            },


            /* PRODUCT */
            {
                path: '/products',
                name: 'products',
                component: Products
            },
            {
                path: '/products/new-product',
                name: 'new-product',
                component: NewProduct
            },
            {
                path: '/products/edit-product/:product_id',
                name: 'edit-product',
                component: NewProduct
            },
            /* SUPPORT TICKET  */
            {
                path: '/support-tickets',
                name: 'support-tickets',
                component: SupportTicketsList
            },
            {
                path: '/support-tickets/raise-issue/',
                name: 'raise-an-issue',
                component: RaiseIssue
            },
            {
                path: '/support-tickets/support-ticket-details/:ticket_id',
                name: 'support-ticket-details',
                component: SupportTicketDetails
            },
            /* SUBSCRIPTIONS */
            {
                path: '/subscriptions',
                name: 'subscription-plans',
                component: Subscriptions
            },
            /* Wholesaler Profile */
            {
                path: '/profile',
                name: 'wholesaler-profile',
                component: WholesaleProfile
            }, {
                path: '/profile/details/',
                name: 'wholesaler-profile-details',
                component: WholesaleProfileDetails
            },
            {
                path: '/profile/edit',
                name: 'wholesaler-edit-profile',
                component: WholesaleEditProfile
            },
            /* ware house profile*/
            {
                path: 'warehouse-profile/',
                name: 'my-profile',
                component: WarehouseProfile
            },

            {
                path: '/manage',
                name: 'manage',
                component: Manage,
                redirect: {
                    name: "manage-retailers"
                },
                children: [

                    /* RETAILER */

                    {
                        path: 'retailer',
                        name: 'manage-retailers',
                        component: ManageRetailer
                    },
                    {
                        path: 'retailer/add-retailer',
                        name: 'add-retailer',
                        component: AddRetailer
                    },
                    {
                        path: 'retailer/edit-retailer/:retailer_id',
                        name: 'edit-retailer',
                        component: AddRetailer
                    },
                    {
                        path: 'retailer/retailer-details/:retailer_id',
                        name: 'retailer-details',
                        component: RetailerDetails
                    },

                    /* Managw Wholesaler */
                    {
                        path: 'wholesaler',
                        name: 'manage-wholesaler',
                        component: ManageWholesaler
                    },
                    {
                        path: 'wholesaler/add-a-wholesaler',
                        name: 'add-a-wholesaler',
                        component: WholesaleEditProfile
                    },
                    {
                        path: 'wholesaler/edit-wholesaler/:wholesaler_id',
                        name: 'edit-wholesaler',
                        component: WholesaleEditProfile
                    },
                    {
                        path: 'wholesaler/wholesaler-details/:wholesaler_id',
                        name: 'wholesaler-details',
                        component: WholesaleProfileDetails
                    },

                    /* AGENTS */
                    {
                        path: 'agent',
                        name: 'manage-team',
                        component: ManageTeam
                    },
                    {
                        path: 'agent/add-an-agent',
                        name: 'add-an-agent',
                        component: AddAgents
                    },
                    {
                        path: 'agent/edit-agent/:agent_id',
                        name: 'edit-agent',
                        component: AddAgents
                    },
                    {
                        path: 'agent/employee-details/:agent_id',
                        name: 'employee-details',
                        component: EmployeeDetails
                    },

                    /*SUBSCRIPTION PLANS*/
                    {
                        path: 'subscription',
                        name: 'manage-subscription-plans',
                        component: SubscriptionPlans
                    },
                    {
                        path: 'subscription/add-a-subscription-plan',
                        name: 'add-a-subscription-plan',
                        component: AddSubscriptionPlan
                    },
                    {
                        path: 'subscription/edit-subscription-plan/:subscription_plan_id',
                        name: 'edit-subscription-plan',
                        component: AddSubscriptionPlan
                    },
                    {
                        path: 'user-subscription/',
                        name: 'user-subscriptions',
                        component: UserSubscription
                    },
                    {
                        path: 'user-subscription/add-new-subscription',
                        name: 'add-new-subscription',
                        component: SubscribeUser
                    },

                    /*PAYOUTS*/
                    {
                        path: 'employee-payout-history',
                        name: 'employee-payout-history',
                        component: Payouts
                    },
                    {
                        path: 'payout-details/:order_id',
                        name: 'payout-details',
                        component: PayoutDetails
                    },
                    /*WAREHOUSES*/
                    {
                        path: 'warehouses',
                        name: 'manage-warehouses',
                        component: Warehouses
                    },
                    {
                        path: 'warehouses/create-warehouse/',
                        name: 'create-warehouse',
                        component: CreateWarehouse
                    },
                    {
                        path: 'warehouses/edit-warehouse/:warehouse_id',
                        name: 'edit-warehouse',
                        component: CreateWarehouse
                    },

                    /* Manage Line */
                    {
                        path: 'line',
                        name: 'manage-line',
                        component: ManageLine
                    },
                    {
                        path: 'line/add-line/',
                        name: 'add-line',
                        component: AddLine
                    },
                    {
                        path: 'line/edit-line/:line_id',
                        name: 'edit-line',
                        component: AddLine
                    },
                    {
                        path: 'line/line-details/:line_id',
                        name: 'line-details',
                        component: LineDetails
                    },

                    {
                        path: 'retailer-offer-image/',
                        name: 'retailer-offer-image',
                        component: RetailerOfferImages
                    },
                    {
                        path: 'wholesaler-offer-image/',
                        name: 'wholesaler-offer-image',
                        component: WholesalerOfferImages
                    },
                ],

            },


            /*Others*/
            {
                path: '/faq',
                name: 'faq',
                component: Faq
            },

        ]
    },
];

const router = new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    routes
})


/* redirecting to home page if access token is not provided*/
var unprotected_routes = ['wholesaler-login', 'warehouse-login', 'signup', 'forget-password', 'verify', 'map']
router.beforeEach((to, from, next) => {


    let access_token = sessionStorage.getItem("token")
    var url = "https://themedx.in/landing-page/index.html";

    if (window.location.href == url) {
        return false
    }

    if (to.name == 'base') {
        location.replace(url)
        return false
    }
    if (to.name == 'map') {
        next()
        return false
    }

    /* retunr  to the subscription-payment-page*/
    if (to.name == 'subscription-payment-page') {
        next()
        return false
    }

    if (!unprotected_routes.includes(to.name) && !access_token) {
        next({
            name: 'wholesaler-login'
        })
    } else {
        if (unprotected_routes.includes(to.name) && access_token) {

            next({
                name: 'overview'
            })
        } else {
            /*  adding dynamic title for the pages */
            let title = to.name.replace(/-/g, ' ').toLowerCase()
                .split(' ')
                .map((s) => s.charAt(0).toUpperCase() + s.substring(1))
                .join(' ');
            window.document.title = "Medx|" + title;
            next();
        }
    }
});


export default router